import { render, staticRenderFns } from "./orderapproverecord.vue?vue&type=template&id=ff4c1382&"
import script from "./orderapproverecord.vue?vue&type=script&lang=js&"
export * from "./orderapproverecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports